import { render, staticRenderFns } from "./index.vue?vue&type=template&id=9c5378c2&scoped=true"
import script from "./index.vue?vue&type=script&lang=ts"
export * from "./index.vue?vue&type=script&lang=ts"
import style0 from "./style/index.scss?vue&type=style&index=0&id=9c5378c2&prod&lang=scss&scoped=true&external"
import style1 from "./index.vue?vue&type=style&index=1&id=9c5378c2&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9c5378c2",
  null
  
)

export default component.exports